import { render, staticRenderFns } from "./VAdministrationTabs.vue?vue&type=template&id=1868ff68&"
import script from "./VAdministrationTabs.vue?vue&type=script&lang=ts&"
export * from "./VAdministrationTabs.vue?vue&type=script&lang=ts&"
import style0 from "./VAdministrationTabs.vue?vue&type=style&index=0&id=1868ff68&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports